module.exports = {"id":"210377","name":"João Teixeira","rating":"72","photo":"./data/images/photos/2/210377.png","club":{"name":"SC Braga","logo":"./data/images/clubs/SCBraga.png"},"positions":["MOC","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoaoTeixeira0.json
// module id = 2039
// module chunks = 0